export default "__VITE_ASSET__BcebD20S__"